import { Enrollment, EnrollmentDto } from './Enrollment';
import { InvoiceStatus } from 'models/payments/InvoiceStatus';
import { utilities } from 'utils/utilities';

export interface InvoiceEnrollmentDto extends EnrollmentDto {
  platformInvoiceId?: string;
  totalMinorUnits: number;
  depositCreditMinorUnits: number;
  currency: string;
  autoCharge: boolean;
  localInvoiceStatus: InvoiceStatus;
  hostedInvoiceUrl?: string;
  description?: string;
  isAwaitingTeamInput?: boolean;
}

export class InvoiceEnrollment extends Enrollment {
  readonly type = 'InvoiceEnrollment';

  platformInvoiceId?: string;
  totalMinorUnits: number;
  depositCreditMinorUnits: number;
  currency: string;
  autoCharge: boolean;
  localInvoiceStatus: InvoiceStatus;
  hostedInvoiceUrl?: string;
  description?: string;
  isAwaitingTeamInput: boolean = false;

  get amountDueMinorUnits(): number {
    return this.totalMinorUnits - this.depositCreditMinorUnits;
  }

  constructor(
    id: string,
    totalMinorUnits: number = 0,
    depositCreditMinorUnits: number = 0,
    currency: string = 'usd',
    autoCharge: boolean = false,
    localInvoiceStatus: InvoiceStatus = InvoiceStatus.Draft,
    platformInvoiceId?: string,
    hostedInvoiceUrl?: string,
    description?: string,
    isAwaitingTeamInput: boolean = false,
  ) {
    super(id);
    this.totalMinorUnits = totalMinorUnits;
    this.depositCreditMinorUnits = depositCreditMinorUnits;
    this.currency = currency;
    this.autoCharge = autoCharge;
    this.localInvoiceStatus = localInvoiceStatus;
    this.platformInvoiceId = platformInvoiceId;
    this.hostedInvoiceUrl = hostedInvoiceUrl;
    this.description = description;
    this.isAwaitingTeamInput = isAwaitingTeamInput;
  }

  toDto(): InvoiceEnrollmentDto {
    return {
      id: this.id,
      enrollmentType: this.type,
      dtoType: 'Models.Api.Dtos.InvoiceEnrollmentDto',
      nodeInstanceId: this.nodeInstanceId,
      requiredSubmissionType: this.requiredSubmissionType,
      status: this.status,
      satisfiedAt: this.satisfiedAt,
      platformInvoiceId: this.platformInvoiceId,
      totalMinorUnits: this.totalMinorUnits,
      depositCreditMinorUnits: this.depositCreditMinorUnits,
      currency: this.currency,
      autoCharge: this.autoCharge,
      localInvoiceStatus: this.localInvoiceStatus,
      hostedInvoiceUrl: this.hostedInvoiceUrl,
      description: this.description,
      isAwaitingTeamInput: this.isAwaitingTeamInput,
    };
  }

  static fromDto(dto?: Partial<InvoiceEnrollmentDto> | InvoiceEnrollment | any): InvoiceEnrollment {
    if (!dto) {
      return new InvoiceEnrollment(utilities.DEFAULT_GUID);
    }
    if (dto instanceof InvoiceEnrollment) {
      return dto;
    }
    const enrollment = new InvoiceEnrollment(
      dto.id ?? utilities.DEFAULT_GUID,
      dto.totalMinorUnits ?? 0,
      dto.depositCreditMinorUnits ?? 0,
      dto.currency ?? 'usd',
      dto.autoCharge ?? false,
      dto.localInvoiceStatus ?? InvoiceStatus.Draft,
      dto.platformInvoiceId,
      dto.hostedInvoiceUrl,
      dto.description,
      dto.isAwaitingTeamInput ?? false,
    );
    enrollment.nodeInstanceId = dto.nodeInstanceId ?? utilities.DEFAULT_GUID;
    enrollment.requiredSubmissionType = dto.requiredSubmissionType ?? '';
    if (dto.status) enrollment.status = dto.status;
    enrollment.satisfiedAt = dto.satisfiedAt;
    return enrollment;
  }
}

Enrollment.register('InvoiceEnrollment', (d?: any) => InvoiceEnrollment.fromDto(d));
Enrollment.register('Models.Enrollments.InvoiceEnrollment', (d?: any) => InvoiceEnrollment.fromDto(d));
